import axios from "axios";
import { getAuthHeader } from "../../utils/get-token";

/**
 *
 * @param {string} url
 * @param {object} params
 * @param {import("axios").CancelToken} cancelToken
 * @returns
 */
export const getAxios = (url, params, cancelToken) => {
	return axios.get(url, {
		params: params,
		cancelToken,
		headers: {
			...getAuthHeader(),
		},
	});
};

/**
 *
 * @param {string} url
 * @param {object} data
 * @param {import("axios").AxiosRequestConfig|undefined} config
 */
export const postAxios = (url, data, config) => {
	return axios.post(url, data, {
		...config,
		headers: {
			...getAuthHeader(),
			"Content-Type": "application/json",
		},
	});
};

/**
 *
 * @param {string} url
 * @param {object} data
 * @param {import("axios").AxiosRequestConfig|undefined} config
 */
export const putAxios = (url, data, config) => {
	return axios.put(url, data, {
		...config,
		headers: {
			...getAuthHeader(),
			"Content-Type": "application/json",
		},
	});
};
